module.exports = __webpack_public_path__ + "img/4_19.4b79e1b3.png";